var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8125 9.375V11.6562H30.3247L20.5312 21.4497L15.6345 16.553C15.4206 16.3391 15.1306 16.219 14.8281 16.219C14.5257 16.219 14.2356 16.3391 14.0217 16.553L2.28125 28.2934L3.89409 29.9062L14.8281 18.9722L19.7248 23.8689C19.9387 24.0828 20.2288 24.2029 20.5312 24.2029C20.8337 24.2029 21.1238 24.0828 21.3377 23.8689L31.9375 13.2691V20.7812H34.2188V9.375H22.8125Z",
    fill: "#1E1E2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonGrowth);
export default __webpack_public_path__ + "static/media/carbon_growth.eef6baa55983187cb7d903c161fa4063.svg";
export { ForwardRef as ReactComponent };